import React from 'react';
import Player from 'xgplayer';
import HlsPlayer from 'xgplayer-hls.js';
import config from '../../assets/js/conf/config.js';
import {localParam} from '../../assets/js/utils/util.js';
import {request} from '../../assets/js/libs/request.js';
import {connect} from 'react-redux';
import { Toast } from 'antd-mobile';
import UpRefresh from "../../assets/js/libs/uprefresh.js";


class VideoComponent extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			"outlineId": props.state.outlineId.Id?props.state.outlineId.Id:localStorage['outlineId'] !== undefined?localStorage['outlineId']:'',
			NewDate: props.NewDate,
			living: props.live
		};
		//console.log(this.state.NewDate)
		this.studyTime = 0;
		this.totalTime = 0;
		this.playTime = 0;
		
		this.timer = null;
		this.player = null;
	}
	componentDidMount(){
		let vdoSrc = this.props.src;
		let vdoLogo = this.props.logo;
		let that = this;
		let currentTime = 0;
		let num = 0;
		//console.log(vdoSrc)
		
		if(this.state.living == 1 || this.state.living == 3){
			if (vdoSrc.indexOf('.m3u8') >= 0) { //判断视频源是否是m3u8的格式或者是直播
			//console.log(1)
				this.player = new HlsPlayer({
			      el:document.querySelector('#mse'),
			      url: vdoSrc,
			      playsinline: false,
			      useHls: true,
			      fitVideoSize: 'auto',
			      "closeVideoClick": true,
			      'x5-playsinline':"true", 
			      'playsinline':"true", 
			      'webkit-playsinline':"true",
			      'autoplay': 'true',				//自动播放
				  'keyShortcut': 'off',
				  'disableProgress': true,			//禁止进度条拖动
				  'closeVideoTouch': true,			//关闭切换播放/暂停状态
				  'ignores': ['time','play','progress']	//关闭内置控件
			  	});
			}else{
				//console.log(2)
				this.player = new Player({
				  el:document.querySelector('#mse'),
				  url: vdoSrc,
				  fitVideoSize: 'auto',
				  "closeVideoClick": true,
				  'x5-playsinline':"true", 
				  'playsinline':"true", 
				  'webkit-playsinline':"true",
				  'autoplay': 'true',				//自动播放
				  'keyShortcut': 'off',
				  'disableProgress': true,			//禁止进度条拖动
				  'closeVideoTouch': true,			//关闭切换播放/暂停状态
				  'ignores': ['time','play','progress']	//关闭内置控件
				});
			}
		}else{
			//console.log(3)
	    	this.player = new Player({
			  el:document.querySelector('#mse'),
			  url: vdoSrc,
			  fitVideoSize: 'auto',
			  playbackRate: [0.5, 0.75, 1, 1.5, 2],
			  "closeVideoClick": true,
			  'x5-playsinline':"true", 
	          'playsinline':"true", 
	          'loop': true,
	          'webkit-playsinline':"true",
			  'autoplay': 'true',				//自动播放
			  'poster': vdoLogo,
			  'closeVideoTouch': true,
			});
	    }
	    this.player.once('play',function(){
	    	//准备
	    	that.totalTime = parseInt(that.player.duration);			//视频总时长
			//console.log(that.player.duration)
	    	//设置播放开始位置
	    	let JSONVIdeo = localStorage['JSONVIdeo']!= undefined?JSON.parse(localStorage['JSONVIdeo']):'';
			//观看进度为秒钟数
	    	if(that.state.living == 1 || that.state.living == 3){
	    		that.player.currentTime = that.state.NewDate/1000;
	    	}else if(JSONVIdeo.url && JSONVIdeo.url == vdoSrc){
				that.player.currentTime = JSONVIdeo.time;
	    	}
	    })
	    this.player.on('playing', function () { //播放中
	       	//"播放中"
			//console.log(that.player.currentTime)
	       	that.timer = setInterval(function(){
	       		that.studyTime += 1;
				num += 1;
				if(num > 59){
					that.subStudy();
					num = 0;
				}
				//console.log(num)
	       	}, 1000)
	    });
	    this.player.on('pause', function () { 
	    	//暂停
			//console.log(that.player.currentTime)
	    	that.playTime = parseInt(that.player.currentTime*1000);		
	        clearInterval(that.timer)

	        let JSONVIdeo = {
	        	url: vdoSrc,
	        	time: that.player.currentTime			//观看进度
	        }
	        localStorage['JSONVIdeo'] = JSON.stringify(JSONVIdeo);
	    });
	    this.player.on('ended', function () { //结束
	        //"播放结束"
	        clearInterval(that.timer);
	        
	        that.subStudy();
	        
	    }, false);
	}
	subStudy(){
		//保存学习进度
		if(this.studyTime<10){
			return
		}
		let data = {
			"outlineId": this.state.outlineId,
			"playTime": this.playTime,
			"studyTime": this.studyTime,
			"totalTime": this.totalTime
		}

		request(config.baseUrl+'api/Study/O01', "post", data).then(res=>{
			if(res.code === 0) {}
		})
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.subStudy();
		//销毁播放器
		this.player.destroy();
		clearInterval(this.timer);
	}
    render(){
        return(
            <div className={'video'}>
		        <div id="mse"></div>
        	</div>
        );
    }
}
export default connect((state)=>{
	return {
		state: state
	}
})(VideoComponent)
